export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const endPointName = {
  Master: {
    getCountry: 'countryMaster/GetCountryMaster',
    getState: 'stateMaster/GetStateMaster',
    getDistrict: 'districtMaster/GetDistrictMaster',
    getExpertise: 'expertiseMaster/GetExpertiseMaster',
    getDocument: 'documentMaster/GetDocumentMaster',
    getAssociate: 'AssociateMaster/GetAssociateMaster',
    getMembership: 'MembershipMaster/GetMembershipMaster',
    getAdminRole: 'AdminRoleMaster/GetAdminRoleMaster',
    getAdminRoleAccess: 'AdminRoleAccessMaster/GetAdminRoleAccessMaster',
    getModuleAccess: 'AdminModuleAccessMaster/GetAdminModuleAccessMaster',
    religion: 'ReligionMaster/GetReligionMaster',
    community: 'Community/GetCommunityMaster',
    eventType: 'Events/GetEventTypeMaster'
  },
  Admin: {
    authorize: 'AdminPanelLogin/AuthorizeUser',
    adminInsertUpdate: 'AdminUserData/AdminUserDataInsert',
    getProfile: 'AdminPanelLogin/GetAuthorizedUserProfile',
    adminList: 'AdminUserData/GetAdminUsersList',
    adminDetails: 'AdminUserData/GetAdminUserDetails',
    sendOtp: 'Verification/MobileNumberVerification',
    verifyOtp: 'Verification/MobileNumberOTPVerification',
    sendEmailOtp: 'Verification/EmailIdVerification',
    verifyEmailOtp: 'Verification/EmailIdOTPVerification',
    loginOTPSend: 'MobileLogin/MobileLoginVerification',
    loginOTPVerify: 'MobileLogin/MobileLoginOTPVerification',
    AdminUserDataUpdate: 'AdminUserData/AdminUserDataUpdate',
    forgotPassword: 'MobileLogin/CheckUserForForgetPassword',
    UpdatePassword: 'AdminPanelLogin/UpdatePassword',
    adminDetails1: 'AdminPanelLogin/AdminMasterDetails'
  },
  Volunteer: {
    volunteerList: 'Volunteer/GetVolunteerList',
    volunteerInsert: 'Volunteer/VolunteerInsert',
    GetVolunteerDetails: 'Volunteer/GetVolunteerDetails',
    volunteerApproval: 'Volunteer/VolunteerApproveRejectBlock',
    VolunteerUpdate: 'Volunteer/VolunteerUpdate',
    forwardVolunteer: 'Volunteer/VolunteerForward',
    volunteerBecomeMember: 'Volunteer/VolunteerBecomeMember',
    asignmentVolunteerList: 'TokenAssignment/GetVolunteerListforTokenAssignment',
    activateAccount: 'Volunteer/VolunteerActivate',
    volunteerTrainingInsert: 'VolunteerTraining/VolunteerTrainingInsert',
    VolunteerTrainingList: 'VolunteerTraining/VolTrainingList',
    deleteTraining: 'VolunteerTraining/DeleteVolTraining',
    volunteerProflUpdate: 'Volunteer/VolMemberUpdateProfile',
    volunteerEmergencyContact: 'Volunteer/UpdateVolRelationData'
  },
  Member: {
    memberInsert: 'Membership/MembershipInsert',
    memberList: 'Membership/GetMembershipList',
    publicMemberList: 'OfflineMembership/MembershipPublicList',
    memberApproval: 'Membership/MembershipApproveRejectBlock',
    memberDetails: 'Membership/GetMembershipDetails',
    forwardMember: 'Membership/MembershipForward',
    memberListBasedOnType: 'Membership/GetMembershipListByTypeCreatedBy',
    referenceInsert: 'MemberReferenceNo/MemberReferenceNoInsert',
    memberBcomeVolunteer: 'Membership/MembershipBecomeVolunteer',
    referenceList: 'MemberReferenceNo/MemberReferenceNoList',
    MembershipUpdate: 'Membership/MembershipUpdate',
    referenceDetails: 'MemberReferenceNo/GetMemberReferenceNoDetails',
    deleteMember: 'MemberReferenceNo/MemberReferenceNoDelete',
    exportToExcel: 'MemberReferenceNo/MembersDataExport',
    transferReference: 'MemberReferenceNo/TransferReferenceNumber',
    closeReferenceNo: 'MemberReferenceNo/CloseReferenceNumber',
    membershipDetails: 'Membership/GetMembershipDetails',
    membershipPaymentDetials: 'Membership/MembershipPaymentList',
    processPayment: 'Membership/MembershipPayment',
    memberShipTransfer: 'Membership/MemberTransfer',
    verifyMember: 'OfflineMembership/MemberIntroducerDetails',
    publicVolunteerList: 'OfflineMembership/PublicVolunteerList',
    renewalRequest: 'Membership/MembershipRenewalRequest'
  },
  Donation: {
    donationInsert: 'Donation/DonationInsert',
    donationPercentageInsert: 'MemberReferenceNo/PercentageShareInsert',
    percentageList: 'MemberReferenceNo/GetPercentageShareList',
    updatePercentage: 'MemberReferenceNo/PercentageShareUpdate',
    deletePerentage: 'Membership/GetMembershipDetails',
    getDonorList: 'Donation/GetDonorsList',
    getDonorDetails: 'Donation/GetDonorsDetails'
  },
  Beneficiary: {
    GetBeneficiaryList: 'Beneficiary/GetBeneficiaryList',
    getVolunteerList: 'Volunteer/GetVolunteerListforBeneficiary',
    GetBeneficiaryDetails: 'Beneficiary/GetBeneficiaryDetails'
  },
  Thalassemia: {
    ThalassemiaInsert: 'Thalassemia/ThalassemiaInsert',
    getThalassemiaList: 'Thalassemia/GetThalassemiaList',
    getThalassemiaDetails: 'Thalassemia/GetThalassemiaDetails'
  },
  BloodDonation: {
    BloodDonationCampInsert: 'BloodDonationCamp/BloodDonationCampInsert',
    GetBloodDonationCampList: 'BloodDonationCamp/GetBloodDonationCampList'
  },
  Event: {
    createEvent: 'Events/EventInsert',
    eventList: 'Events/GetEventsListForAdmin',
    eventDetails: 'Volunteer/GetVolunteerDetails',
    updateEvent: 'Events/EventUpdate',
    closeEvent: 'Events/EventClose',
    getEventbasedOnType: 'Events/GetEventsListForAdminBasedOnEventType',
    latest_event_details: 'Events/GetEventDetails',
    eventTokenExport: 'Events/VolunteerExportEventData'
  },
  Token: {
    createToken: 'Tokens/TokenInsert',
    tokenList: 'Tokens/GetAdminTokensList',
    tokenDetails: 'Volunteer/GetVolunteerDetails',
    updateToken: '',
    tokenBeneficiaryList: 'Tokens/GetAdminBeneficiaryList',
    tokenAsignment: 'TokenAssignment/TokenAssignToVolunteer',
    beneficiaryforTokenCreation: 'Tokens/GetAdminBeneficiaryListForTokenCreation',
    latest_token_details: 'Tokens/GetTokenDetails',
    tokenExport: 'Tokens/ExportTokenData'
  },
  Items: {
    createItem: 'ItemsMaster/ItemMasterInsert',
    itemList: 'ItemsMaster/GetItemsMaster',
    updateItem: 'ItemsMaster/ItemMasterUpdate',
    deleteItem: 'ItemsMaster/ItemMasterDelete'
  },
  Timesheet: {
    create: 'Timesheet/TimesheetInsert',
    list: 'Timesheet/GetTimesheetList',
    update: 'Timesheet/TimesheetUpdate',
    delete: 'ItemsMaster/ItemMasterDelete',
    approveReject: 'Timesheet/TimesheetApprovalReject'
  },
  Dashboard: {
    GetDashboardData: 'Dashboard/GetDashboardData'
  }
};
